import { useLocalisation } from '@3plearning/lingui-cdn';

export const useTranslations = () => {
    const { i18n } = useLocalisation();

    return {
        participation: i18n.t`Table Header - Participation`,
        certificates: i18n.t`Certificates - Certificates`,
        oldCertificates: i18n.t`Certificates - Old Certificates`,
        bronze: i18n.t`Certificates - Bronze`,
        silver: i18n.t`Certificates - Silver`,
        gold: i18n.t`Certificates - Gold`,
        platinum: i18n.t`Certificates - Platinum`,
        emerald: i18n.t`Certificates - Emerald`,
        diamond: i18n.t`Certificates - Diamond`,
        epic: i18n.t`Certificates - Epic`,
        legend: i18n.t`Certificates - Legend`,
        allClasses: i18n.t`Certificates - All Classes`,
        allYearGroups: i18n.t`Certificates - All Year Groups`
    };
};



// WEBPACK FOOTER //
// ./containers/participation/hooks/use-translations.js